import React from "react";
import styles from './panel-button.module.css'

export default function PanelButton({imageSrc, onClickFunction, className}) {
    return (
        <div className={`${styles.panelButton} ${className ? className : ''}`} onClick={onClickFunction}>
            <img src={imageSrc}></img>
        </div>
    );
}